import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import Flux360Store from './flux360/Flux360Store';
const store = new Vuex.Store({
    modules: {
        flux360: Flux360Store
    }
});

// Hand to the session store the tour info and the vuex store
//const options = {
    //store
//}

//import FluxWebCommunication from 'flux-web-communication';
//Vue.use(FluxWebCommunication, options);

export default store;
